import script from "./AccessInvite.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccessInvite.vue?vue&type=script&setup=true&lang=ts"

import "./AccessInvite.vue?vue&type=style&index=0&id=74764a89&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74764a89"]])

export default __exports__